import React from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { Container, Row, Col, Button } from 'reactstrap'
import { Breadcrumbs } from '../../AbstractElements'
import { Student911CollegeProfile } from '../StudentCollegeProfile/Student911CollegeProfile'

const CollegeProfile = () => {
	const { id } = useParams()
	const navigate = useNavigate()

	return (
		<>
			<Breadcrumbs parent="Student Management" title="College Profile" mainTitle="College Profile" />
			<Container fluid={true}>
				<Row>
					<Col sm="12">
						<div className="d-flex justify-content-between align-items-center mb-3">
							<Button color="outline-secondary" onClick={() => navigate(-1)} className="btn-sm">
								<i className="fa fa-arrow-left me-2"></i>
								Back
							</Button>
						</div>
					</Col>
				</Row>
			</Container>
			<Student911CollegeProfile studentId={id} />
		</>
	)
}

export { CollegeProfile }
